// extracted by mini-css-extract-plugin
export default {"images-container":"resource-images_images-container__jHupU","images-container--empty":"resource-images_images-container--empty__k2bK6"};